import * as parameterApi from './parameterApi';
import * as parameterActions from './parameterActions';

export function getParameterList() {
  return (dispatch) => {
    parameterApi.getParameterList().then((response) => {
      if (response && response.data) {
        dispatch(parameterActions.setParameterList(response.data));
      }
    });
  };
}

export function addParameter(parameter, cb) {
  return (dispatch) => {
    parameterApi.addParameter(parameter).then((response) => {
      if (response && response.data) {
        dispatch(parameterActions.addParameter(response.data));
        cb();
      }
    });
  };
}

export function updateParameter(parameter, cb) {
  return (dispatch) => {
    parameterApi.updateParameter(parameter).then((response) => {
      if (response && response.data) {
        dispatch(parameterActions.updateParameter(response.data));
        cb();
      }
    });
  };
}

export function deleteParameter(parameter) {
  return (dispatch) => {
    parameterApi.deleteParameter(parameter).then((response) => {
      if (response) {
        dispatch(parameterActions.deleteParameter(parameter.id));
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/parameter/parameterServices.js